<template>
    <VMenu v-model="exibirDatePicker" :close-on-content-click="false" :nudge-right="30"
           lazy no-title transition="scale-transition" offset-y full-width min-width="290px"
           color="primary" :disabled="somenteLeitura">
        <template v-slot:activator="{on}">
            <VTextField :label="label" v-model="aux"
                    prepend-icon="event"
                    :clearable="clearable"
                    @click:clear="data = null"
                    @input="formatarDataPT"
                    :disabled="somenteLeitura"
                    mask="##/##/####"
                    return-masked-value
                    v-on="on" color="primary" :rules="rules"/>
        </template>
        <VDatePicker locale="pt" :no-title="true" v-model="data"
                     :disabled="somenteLeitura"
                     :min="min"
                     :max="max"
                     :change="(onChangeFunc ? onChangeFunc() : ()=>{})"
                     @input="exibirDatePicker = false; formatarDataEN()" color="primary"/>
    </VMenu>
</template>
<script>
    import moment from 'moment';
    import datas from "../mixins/datas";
    export default {
        mixins: [datas],
        name: 'SelecaoData',
        data() {
            return {
                exibirDatePicker: false,
                data: null,
                aux: null,
            }
        },
        async activated(){
            this.aux = null
            if(this.agendamentoOnline){
                var dataAtt = moment(this.data, "YYYY-MM-DD");
                this.aux = dataAtt.format("DD/MM/YYYY").toString();
            }
        },
        async deactivated(){
            this.aux=null
            this.data=null
        },
        methods: {
            formatarDataPT(){
                if(this.aux.length >= 10){
                    var dataAtt = moment(this.aux, "DD/MM/YYYY");
                    if(dataAtt.isValid()){
                        this.data = dataAtt.format("YYYY-MM-DD");
                        return
                    } else {
                        this.aux=null
                        return
                    }
                }
                return;
            },
            formatarDataEN(){
                var dataAtt = moment(this.data, "YYYY-MM-DD");
                this.aux = dataAtt.format("DD/MM/YYYY");
                return;
            }
        },
        props: {
            somenteLeitura: Boolean,
            clearable: Boolean,
            value: {},
            label: String,
            rules: Array,
            min: String,
            max: String,
            onChangeFunc: Function,
            agendamentoOnline: Boolean
        },
        computed: {
            dataFormatada() {
                return this.formatarData(this.data);
            },
        },
        watch: {
            value: {
                immediate: true,
                handler(v) {
                    this.data = v;
                    var dataAtt = moment(this.data, "YYYY-MM-DD");
                    this.aux = dataAtt.format("DD/MM/YYYY") === "Data inválida" ? null : dataAtt.format("DD/MM/YYYY");
                }
            },
            data(d) {
                if (d !== this.value) {
                    this.$emit('input', d);
                }
            }
        }
    }
</script>
